import { gql } from '../__generated__';

const ModelItem = gql(`
  fragment SubscriptionModelItem on SubscriptionModel {
    id
    bksId
    name
    parentId
    price {
      singleUser
      extraUser
    }
    pendingPriceChange {
      id
      timeOfChange
      newPrice {
        singleUser
        extraUser
      }
    }
  }
`);

export let GET_SUBSCRIPTIONS = gql(`
  query GetSubscriptions {
    subscriptions: getSubscriptions {
      ...SubscriptionModelItem
    }
  }
`);

export const UPDATE_PRICE = gql(`
  mutation ChangeSubscriptionPrice($input: ChangeSubscriptionPriceInput!) {
    changeSubscriptionPrice(input: $input) {
      ...SubscriptionModelItem
    }
  }
`);

export const CANCEL_PRICE_UPDATE = gql(`
  mutation CancelSubscriptionPriceChange($input: CancelSubscriptionPriceChangeInput!) {
    cancelSubscriptionPriceChange(input: $input) {
      ...SubscriptionModelItem
    }
  }
`);

export const GET_CHANGES = gql(`
  query GetChanges($offset: Int, $limit: Int) {
    queryResult: getSubscriptionChanges(offset: $offset, limit: $limit) {
      totalCount
      changes {
        id
        isExternal
        description
        createdAt
        createdByName
      }
    }
  }
`);
